export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
		},
	],
	singular_model_name_spanish: 'Plantilla',
	plural_model_name_spanish: 'Plantilla',
	create_model_name_spanish: 'Nueva Plantilla',
	text_delete: 'la',
}